declare global {
  interface Window {
    __ENV__?: {
      VITE_API_URL?: string;
      VITE_ROCKETCHAT_URL?: string;
      VITE_ENABLE_CHAT?: string;
      VITE_ENABLE_CHAT_ADMIN?: string;
      VITE_ENABLE_BANKING?: string;
      VITE_IS_DEMO?: string;
    };
  }
}

function readEnv(key: keyof NonNullable<Window["__ENV__"]>): string {
  return window.__ENV__?.[key] ?? "";
}

function readFlag(key: keyof NonNullable<Window["__ENV__"]>): boolean {
  return readEnv(key) === "true";
}

export const runtimeConfig = {
  apiUrl: readEnv("VITE_API_URL"),
  rocketchatUrl: readEnv("VITE_ROCKETCHAT_URL"),
  enableChat: readFlag("VITE_ENABLE_CHAT"),
  enableChatAdmin: readFlag("VITE_ENABLE_CHAT_ADMIN"),
  enableBanking: readFlag("VITE_ENABLE_BANKING"),
  isDemo: readFlag("VITE_IS_DEMO"),
};

export {};
